<template>
  <div
    data-test-id="showtimes-by-film"
  >
    <div
      v-if="showingsQuery.loaded && moviesAndShowingsByDate.length == 0"
      class="message text-subtitle1 text-weight-bolder column justify-center items-center q-gutter-md"
      :class="{ 'text-white': showtimesUseDarkMode }"
      :style="{ 'font-size': !isMobileView ? '32px' : '26px' }"
      style="margin: 100px 0px"
    >
      <q-icon
        name="videocam"
        size="xl"
        class="q-ma-sm"
      />
      {{ $t('showing.nothingScheduled') }}

      <template v-if="isNextShowingsAvailable">
        {{ $t('time.today') }}
        <q-btn
          unelevated
          color="primary"
          :text-color="buttonTextColor"
          class="q-my-lg"
          :label="$tc('showing.actions.viewNext', 2)"
          :style="{ 'border-radius': `${borderRadius}px` }"
          @click="$emit('view-next-showings')"
        />
      </template>
      <template v-else-if="!isMoviePage && isFiltered">
        <small
          class="text-weight-regular"
          style="font-size: 20px;"
        >{{ $t('showing.removeSearchFiltersPrompt') }}.</small>
        <q-btn
          unelevated
          color="primary"
          :text-color="buttonTextColor"
          :label="$tc('search.actions.clearFilters', 1)"
          :style="{ 'border-radius': `${borderRadius}px` }"
          @click="$emit('clear-filters')"
        />
      </template>
    </div>

    <div
      v-if="!showingsQuery.loaded"
      class="row justify-center"
    >
      <q-spinner
        size="md"
        color="grey"
      />
    </div>

    <!-- We have a showtimes-->

    <div
      v-if="showtimesDisplayType === SHOWTIMES_DISPLAY_TYPES.LIST"
      class="main-display"
      :class="{ container: isMoviePage && !$register }"
    >
      <div
        v-if="showCurrentLocationButton"
        class="row q-mb-md"
      >
        <use-current-location-button
          @current-location-request="handleCurrentLocationRequest"
          @current-location-response="handleCurrentLocationResult"
        />
      </div>
      <component
        :is="($register && allMovies) ? 'q-scroll-area' : showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER ? 'swiper' : 'div'"
        :key="changeCount"
        :class="{
          'absolute-full': $register && allMovies,
          'column full-width': !$register && !allMovies && isMoviePage,
          'bg-responsive': $register
        }"
        :style="{
          'margin-top': marginTop,
          'z-index': $register && allMovies ? '0' : ''
        }"
        v-bind="swiperOptions"
      >
        <component
          :is="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER ? 'swiper-slide' : 'div'"
          v-for="movieAndShowings in sortedMovieAndShowingsByDate"
          :key="movieAndShowings.movie.id"
          class="row movie-container"
          :class="{
            'no-background items-center register': $register,
            'q-pt-xl q-pa-md justify-center': $register && !isCompactLayout,
            'transparent': isMoviePage && !$register,
            'q-py-lg': !isMoviePage && !$register && !isMobileView,
            'content-center': !isMoviePage,
            'col': showtimesViewType === SHOWTIMES_VIEW_TYPES.BLOCK,
            'q-mb-xs': showtimesViewType === SHOWTIMES_VIEW_TYPES.BLOCK && (widgetIncludeBannerBackground || showtimesBlocksBackgroundColor),
            [`bg-${showtimesBlocksBackgroundColor}`]: !!showtimesBlocksBackgroundColor && showtimesBlocksBackgroundColor !== 'custom',
            [movieAndShowings.movie.displayMetaData && movieAndShowings.movie.displayMetaData.classes]: true

          }"
          style="position: relative; overflow: hidden;"
          :style="{
            'border-bottom': !isMoviePage && !$register && showtimesViewType === SHOWTIMES_VIEW_TYPES.BLOCK && !widgetIncludeBannerBackground && !showtimesBlocksBackgroundColor ? '1px solid grey' : undefined,
            'padding-bottom': showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER && sliderPaginationVisible ? '50px' : undefined,
            'background-color': showtimesBlocksBackgroundColor === 'custom' ? showtimesBlocksBackgroundColorHex : undefined,
            'border-radius': `${borderRadius}px`
          }"
          data-test-id="showtimes-by-film-movie-container"
        >
          <div
            v-if="!$register && allMovies"
            class="absolute-full"
          >
            <img
              v-if="movieAndShowings.movie.bannerImageUrl && !($register || !widgetIncludeBannerBackground)"
              class="full-size"
              :src="movieAndShowings.movie.bannerImageUrl"
              style="z-index: 0; object-fit: cover; width: 100%; height: 100%; position: relative;"
              :style="bannerStyle"
            >
          </div>
          <div
            v-if="allMovies && $register && !isCompactLayout"
            class="text-h6 text-bold absolute-top q-ma-sm"
            style="z-index: 1; top: 10px; left: 12px;"
          >
            {{ movieAndShowings.movie.name }}
          </div>
          <div
            class="row"
            :class="[$register ? 'full-width' : 'container', isCompactLayout && 'no-wrap']"
            style="z-index: 1;"
          >
            <template
              v-if="allMovies && !$register"
            >
              <div
                v-if="useBanner && showMovieImage"
                class="col-12 row self-start cursor-pointer"
                :class="{ 'col-sm-6': !isPhonePreview }"
                style="z-index: 1;"
                @click="$emit('select-movie', movieAndShowings.movie)"
              >
                <q-card
                  class="col movie bg-transparent overflow-hidden"
                  :class="('shadow-' + shadow)"
                  :style="{ 'border-radius': `${borderRadius}px` }"
                >
                  <q-img
                    class="full-height"
                    :src="movieAndShowings.movie.bannerImageUrl"
                    :alt="movieAndShowings.movie.name"
                    no-spinner
                    no-transition
                  >
                    <span
                      v-if="showClass && movieAndShowings.movie.titleClass"
                      class="q-ma-sm q-px-sm bg-primary text-white absolute-top-right shadow-6 text-weight-bold"
                      :class="$_.kebabCase(movieAndShowings.movie.titleClass.name)"
                      :style="{ 'border-radius': `${borderRadius}px` }"
                      style="z-index: 2"
                    >{{ movieAndShowings.movie.titleClass.name }}
                    </span>
                    <q-btn
                      v-if="movieAndShowings.movie.trailerYoutubeId && showTrailerButton"
                      round
                      outline
                      color="white"
                      size="md"
                      padding="md"
                      class="watch-trailer-btn absolute-center shadow-6 row"
                      icon="play_arrow"
                      style="z-index: 2"
                      :style="{ 'border-radius': `${borderRadius}px` }"
                      @click.stop="$emit('play-trailer', movieAndShowings.movie.trailerYoutubeId); $trackEvent($customerEvents.MOVIE_PAGE_TRAILER_BUTTON, movieAndShowings.movie.trackingData)"
                    />
                    <q-badge
                      v-if="!cleanImage && enableLeavingSoonBanner && movieAndShowings.movie.displayMetaData.classes.includes('leaves-soon')"
                      class=" text-white text-weight-bold justify-center absolute-bottom full-width inset-shadow bg-negative"
                      style="line-height: auto; min-height: auto; border-radius: 0; padding: 5px; z-index: 2;"
                    >
                      <template
                        v-if="movieAndShowings.movie.displayMetaData.classes.includes('leaves-soon')"
                      >
                        <template
                          v-if="movieAndShowings.movie.displayMetaData.classes.includes('last-day-tomorrow')"
                        >
                          {{ $t('time.endsTomorrow') }}
                        </template>
                        <template
                          v-else-if="movieAndShowings.movie.displayMetaData.classes.includes('last-day-today')"
                        >
                          {{ $t('time.endsToday') }}
                        </template>
                        <template
                          v-else
                        >
                          {{ $t('time.leavesSoon') }}
                        </template>
                      </template>
                    </q-badge>
                  </q-img>
                  <q-badge
                    v-if="cleanImage && enableLeavingSoonBanner && movieAndShowings.movie.displayMetaData.classes.includes('leaves-soon')"
                    class=" text-white text-weight-bold justify-center full-width inset-shadow bg-negative"
                    style="line-height: auto; min-height: auto; padding: 5px;"
                  >
                    <template
                      v-if="movieAndShowings.movie.displayMetaData.classes.includes('leaves-soon')"
                    >
                      <template
                        v-if="movieAndShowings.movie.displayMetaData.classes.includes('last-day-tomorrow')"
                      >
                        {{ $t('time.endsTomorrow') }}
                      </template>
                      <template
                        v-else-if="movieAndShowings.movie.displayMetaData.classes.includes('last-day-today')"
                      >
                        {{ $t('time.endsToday') }}
                      </template>
                      <template
                        v-else
                      >
                        {{ $t('time.leavesSoon') }}
                      </template>
                    </template>
                  </q-badge>
                </q-card>
              </div>
              <template v-else>
                <div
                  v-if="showMovieImage"
                  class="col-5 cursor-pointer"
                  :class="{
                    'col-sm-3': !isPhonePreview && showMovieSynopsis,
                    'col-sm-2': !isPhonePreview && !showMovieSynopsis,
                    [movieAndShowings.movie.displayMetaData && movieAndShowings.movie.displayMetaData.classes]: true
                  }"
                  @click="$emit('select-movie', movieAndShowings.movie)"
                >
                  <q-card
                    class="col movie bg-transparent q-pa-xs overflow-hidden"
                    :class="('shadow-' + shadow)"
                    :style="{ 'border-radius': `${borderRadius}px` }"
                  >
                    <q-img
                      :ratio="2/3"
                      :src="movieAndShowings.movie.posterImageUrl"
                      :alt="movieAndShowings.movie.name"
                      no-spinner
                      no-transition
                    >
                      <span
                        v-if="showClass && movieAndShowings.movie.titleClass"
                        class="q-ma-sm q-px-sm bg-primary text-white absolute-top-right shadow-6 text-weight-bold"
                        :class="$_.kebabCase(movieAndShowings.movie.titleClass.name)"
                        :style="{ 'border-radius': `${borderRadius}px` }"
                        style="z-index: 2"
                      >{{ movieAndShowings.movie.titleClass.name }}
                      </span>
                      <q-btn
                        v-if="movieAndShowings.movie.trailerYoutubeId && showTrailerButton"
                        square
                        color="primary"
                        size="sm"
                        padding="sm"
                        class="watch-trailer-btn absolute-top-left shadow-6 row"
                        icon="play_arrow"
                        style="z-index: 2"
                        :style="{ 'border-radius': `${borderRadius}px` }"
                        @click.stop="$emit('play-trailer', movieAndShowings.movie.trailerYoutubeId); $trackEvent($customerEvents.MOVIE_PAGE_TRAILER_BUTTON, movieAndShowings.movie.trackingData)"
                      />
                      <q-badge
                        v-if="!cleanImage && enableLeavingSoonBanner && movieAndShowings.movie.displayMetaData.classes.includes('leaves-soon')"
                        class="text-white text-weight-bold absolute-bottom justify-center full-width inset-shadow bg-negative"
                        style="line-height: auto; min-height: auto; border-radius: 0; padding: 5px; z-index: 2;"
                      >
                        <template
                          v-if="movieAndShowings.movie.displayMetaData.classes.includes('leaves-soon')"
                        >
                          <template
                            v-if="movieAndShowings.movie.displayMetaData.classes.includes('last-day-tomorrow')"
                          >
                            {{ $t('time.endsTomorrow') }}
                          </template>
                          <template
                            v-else-if="movieAndShowings.movie.displayMetaData.classes.includes('last-day-today')"
                          >
                            {{ $t('time.endsToday') }}
                          </template>
                          <template
                            v-else
                          >
                            {{ $t('time.leavesSoon') }}
                          </template>
                        </template>
                      </q-badge>
                    </q-img>
                    <q-badge
                      v-if="cleanImage && enableLeavingSoonBanner && movieAndShowings.movie.displayMetaData.classes.includes('leaves-soon')"
                      class="text-white text-weight-bold justify-center full-width inset-shadow bg-negative"
                      style="line-height: auto; min-height: auto; padding: 5px;"
                    >
                      <template
                        v-if="movieAndShowings.movie.displayMetaData.classes.includes('leaves-soon')"
                      >
                        <template
                          v-if="movieAndShowings.movie.displayMetaData.classes.includes('last-day-tomorrow')"
                        >
                          {{ $t('time.endsTomorrow') }}
                        </template>
                        <template
                          v-else-if="movieAndShowings.movie.displayMetaData.classes.includes('last-day-today')"
                        >
                          {{ $t('time.endsToday') }}
                        </template>
                        <template
                          v-else
                        >
                          {{ $t('time.leavesSoon') }}
                        </template>
                      </template>
                    </q-badge>
                  </q-card>
                </div>
                <div
                  class="cursor-pointer column justify-start"
                  :class="{
                    'text-white': showtimesUseDarkMode || widgetIncludeBannerBackground || showtimesBlocksTextLight,
                    'col-7': showMovieImage,
                    'col-12': !showMovieImage,
                    'col-sm-3': !isPhonePreview && showMovieImage,
                    'col-sm-5': !isPhonePreview && !showMovieImage
                  }"
                  style="z-index: 1;"
                  @click="$emit('select-movie', movieAndShowings.movie)"
                >
                  <div class="col-auto">
                    <div
                      class="text-h5 q-px-md"
                      :class="{ 'q-pt-sm': isMobileView }"
                    >
                      {{ movieAndShowings.movie.name }}
                      <rated
                        v-if="movieAndShowings.movie.rating"
                        :outline="false"
                        color="secondary"
                        :rated="movieAndShowings.movie.rating"
                        :rating-reason="movieAndShowings.movie.ratingReason"
                        size="md"
                        dense
                        :add-padding="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER"
                        class="q-px-xs"
                      />
                    </div>
                    <div class="q-px-md">
                      <span
                        v-if="movieAndShowings.movie.formattedDuration"
                      >{{ movieAndShowings.movie.formattedDuration }}</span>
                      <span
                        v-if="movieAndShowings.movie.formattedDuration && movieAndShowings.movie.genre"
                        class="q-mx-sm"
                      >&middot;</span>
                      <span
                        v-if="movieAndShowings.movie.genre"
                      >
                        {{ movieAndShowings.movie.genre }}
                      </span>
                      <template v-if="showShowingBadge && showingBadges[movieAndShowings.movie.id].common && $q.screen.gt.sm">
                        <span
                          v-if="movieAndShowings.movie.formattedDuration || movieAndShowings.movie.genre"
                          class="q-mx-sm"
                        >&middot;</span>
                        <showing-badge
                          v-for="showingBadge in showingBadges[movieAndShowings.movie.id].common"
                          :key="showingBadge.id"
                          class="col-auto transparent"
                          dense
                          :color="showtimesUseDarkMode || widgetIncludeBannerBackground || showtimesBlocksTextLight ? 'white' : 'black'"
                          :size="!$register ? 'sm' : 'md'"
                          :showing-badge="showingBadge"
                          :force-icon="isPhonePreview"
                          outline
                          clickable
                          @click="$emit('toggle-showing-badge', showingBadge.id)"
                        />
                      </template>
                    </div>
                  </div>
                  <div
                    v-if="showMovieSynopsis"
                    class="col"
                    :class="{ 'relative-position overflow-hidden': autoResizeMaxClampCount }"
                  >
                    <!-- eslint-disable vue/no-v-html -->

                    <q-resize-observer
                      v-if="autoResizeMaxClampCount"
                      @resize="(size) => onResize(movieAndShowings.movie.id, size)"
                    />
                    <div
                      class="q-mt-sm q-px-md text-body1"
                      :class="{
                        'ellipsis-lines': movieSynopsisWrapped,
                        'absolute': autoResizeMaxClampCount
                      }"
                      :style="{ '-webkit-line-clamp': getWebkitLineClampCounts(movieAndShowings.movie.id) }"
                      v-html="movieAndShowings.movie.synopsisWithBreaks "
                    />
                    <!-- eslint-enable vue/no-v-html -->
                  </div>
                </div>
              </template>
            </template>
            <div
              v-if="allMovies && $register"
              class="col-auto column items-center justify-center"
            >
              <q-img
                no-spinner
                no-transition
                :ratio="2/3"
                :src="movieAndShowings.movie.posterImageUrl"
                :alt="movieAndShowings.movie.name"
                class="poster register cursor-pointer"
                :class="{ 'compact': isCompactLayout }"
                @click="$emit('select-movie', movieAndShowings.movie)"
              />
              <div
                v-if="!isCompactLayout"
                class="row justify-center"
                style="max-width: 100px;"
              >
                <rated
                  v-if="movieAndShowings.movie.rating"
                  :rated="movieAndShowings.movie.rating"
                  :rating-reason="movieAndShowings.movie.ratingReason"
                  dense
                  outline
                  :size="'md'"
                  class="q-ma-xs"
                  :light-text="showtimesUseDarkMode"
                />
                <template v-if="showShowingBadge || !!showingBadges[movieAndShowings.movie.id].common">
                  <showing-badge
                    v-for="showingBadge in showingBadges[movieAndShowings.movie.id].common"
                    :key="showingBadge.id"
                    class="col-auto"
                    :showing-badge="showingBadge"
                    :outline="$register || !widgetIncludeBannerBackground"
                    :color="showtimesUseDarkMode ? 'grey-4' : 'responsive'"
                    :solid="solidShowingBadges"
                    clickable
                    :data-test-id="`showtimes-by-film-showing-badge-${showingBadge.iconName && showingBadge.iconName.replace('_', '-')}`"
                    @click="$emit('toggle-showing-badge', showingBadge.id)"
                  />
                </template>
              </div>
            </div>
            <div
              v-if="allMovies && isCompactLayout"
              :class="showtimesUseDarkMode ? 'text-responsive' : 'text-grey-9'"
              class="col-auto q-px-xs q-pt-sm"
              style="width: 190px"
            >
              <div
                class="text-subtitle1 text-weight-bolder q-pl-xs q-mb-sm"
                style="line-height: 1.1em;"
              >
                {{ movieAndShowings.movie.name }}
              </div>
              <div class="text-body2 q-pl-sm q-mb-xs q-gutter-x-xs">
                <rated
                  v-if="movieAndShowings.movie.rating"
                  :rated="movieAndShowings.movie.rating"
                  :rating-reason="movieAndShowings.movie.ratingReason"
                  class="q-ml-none"
                  :light-text="showtimesUseDarkMode"
                />
                <span
                  v-if="movieAndShowings.movie.formattedDuration"
                >
                  <template v-if="movieAndShowings.movie.rating">&nbsp;&middot;&nbsp;</template>
                  {{ movieAndShowings.movie.formattedDuration }}</span>
                <span
                  v-if="movieAndShowings.movie.genre"
                >
                  <template v-if="movieAndShowings.movie.formattedDuration || movieAndShowings.movie.rating">&nbsp;&middot;&nbsp;</template>
                  {{ movieAndShowings.movie.genre }}
                </span>
              </div>
              <template v-if="!!showingBadges[movieAndShowings.movie.id].common">
                <template v-if="movieAndShowings.movie.formattedDuration || movieAndShowings.movie.rating || movieAndShowings.movie.genre">
                  &nbsp;&middot;&nbsp;
                </template>
                <showing-badge
                  v-for="showingBadge in showingBadges[movieAndShowings.movie.id].common"
                  :key="showingBadge.id"
                  :showing-badge="showingBadge"
                  :outline="$register || !widgetIncludeBannerBackground"
                  :color="showtimesUseDarkMode ? 'grey-4' : 'responsive'"
                  :solid="solidShowingBadges"
                  clickable
                  @click="$emit('toggle-showing-badge', showingBadge.id)"
                />
              </template>
            </div>
            <div
              :class="{
                'column': $register,
                'overflow-auto hide-scrollbar': isCompactLayout ,
                'full-width': isMoviePage,
                'col-12 q-py-md': ($q.screen.lt.sm || isPhonePreview) && !isMoviePage,
                'q-px-sm': ($q.screen.lt.md || isPhonePreview) && !isMoviePage && useBanner,
                'col-sm-6': (showMovieImage || showMovieSynopsis) && !isPhonePreview,
                'col-sm-7': (!showMovieImage && !showMovieSynopsis) && !isPhonePreview
              }"
              :style="$register ? !isMoviePage ? 'flex-grow: 1; max-width: calc(100% - 130px);' : 'flex-grow: 1; max-width: 100%;' : ''"
              style="z-index: 1;"
            >
              <div
                v-if="useBanner && showMovieImage"
                class="q-pb-sm cursor-pointer"
                :class="{ 'q-pl-md': !isMobileView }"
                @click="$emit('select-movie', movieAndShowings.movie)"
              >
                <div
                  :class="{
                    'text-white': showtimesUseDarkMode || widgetIncludeBannerBackground || showtimesBlocksTextLight,
                    'q-pr-md': showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER
                  }"
                >
                  <template v-if="showShowingBadge && $_.some(showingBadges[movieAndShowings.movie.id].common, showingBadge => { return showingBadge.type === 'name' }) && isMobileView">
                    <showing-badge
                      v-for="showingBadge in $_.filter(showingBadges[movieAndShowings.movie.id].common, showingBadge => { return showingBadge.type === 'name' })"
                      :key="showingBadge.id"
                      class="col-auto q-ml-none"
                      dense
                      outline
                      :color="widgetIncludeBannerBackground || showtimesUseDarkMode || showtimesBlocksTextLight ? 'grey-4' : 'secondary'"
                      size="md"
                      :showing-badge="showingBadge"
                      clickable
                      @click="$emit('toggle-showing-badge', showingBadge.id)"
                    />
                  </template>

                  <div
                    class="text-h5"
                    :class="{ 'row justify-between items-center': isMobileView }"
                  >
                    {{ movieAndShowings.movie.name }}
                    <rated
                      v-if="!isMobileView && movieAndShowings.movie.rating"
                      :outline="false"
                      :color="'secondary'"
                      :text-color="'white'"
                      :rated="movieAndShowings.movie.rating"
                      :rating-reason="movieAndShowings.movie.ratingReason"
                      :size="'md'"
                      dense
                      :add-padding="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER"
                      class="q-px-md"
                    />
                    <div
                      v-if="isMobileView && movieAndShowings.movie.name.length < 15"
                      class="col-auto row justify-between items-center"
                    >
                      <template v-if="showShowingBadge && $_.some(showingBadges[movieAndShowings.movie.id].common, showingBadge => { return showingBadge.type !== 'name'})">
                        <showing-badge
                          v-for="showingBadge in $_.filter(showingBadges[movieAndShowings.movie.id].common, showingBadge => { return showingBadge.type !== 'name' })"
                          :key="showingBadge.id"
                          class="col-auto"
                          dense
                          outline
                          :color="widgetIncludeBannerBackground || showtimesUseDarkMode || showtimesBlocksTextLight ? 'grey-4' : 'secondary'"
                          size="md"
                          :showing-badge="showingBadge"
                          force-icon
                          clickable
                          @click="$emit('toggle-showing-badge', showingBadge.id)"
                        />
                      </template>
                      <rated
                        v-if="movieAndShowings.movie.rating"
                        :outline="false"
                        :color="'secondary'"
                        :text-color="'white'"
                        :rated="movieAndShowings.movie.rating"
                        :rating-reason="movieAndShowings.movie.ratingReason"
                        :size="'md'"
                        dense
                        :add-padding="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER"
                        class="q-px-md col"
                      />
                    </div>
                  </div>
                  <div
                    :class="{ 'row justify-between items-center': isMobileView }"
                  >
                    <div>
                      <span
                        v-if="movieAndShowings.movie.formattedDuration"
                      >{{ movieAndShowings.movie.formattedDuration }}</span>
                      <span
                        v-if="movieAndShowings.movie.genre"
                      >
                        <template v-if="movieAndShowings.movie.formattedDuration">&nbsp;&middot;&nbsp;</template>
                        {{ movieAndShowings.movie.genre }}
                      </span>
                      <template v-if="showShowingBadge && showingBadges[movieAndShowings.movie.id].common && $q.screen.gt.sm && !isPhonePreview">
                        <template
                          v-for="showingBadge in showingBadges[movieAndShowings.movie.id].common"
                          :key="showingBadge.id"
                        >
                          &nbsp;&middot;&nbsp;
                          <showing-badge
                            class="col-auto transparent q-pa-none"
                            :color="widgetIncludeBannerBackground || showtimesUseDarkMode || showtimesBlocksTextLight ? 'grey-4' : 'dark'"
                            dense
                            :size="!$register ? 'sm' : 'md'"
                            :showing-badge="showingBadge"
                            clickable
                            @click="$emit('toggle-showing-badge', showingBadge.id)"
                          />
                        </template>
                      </template>
                    </div>
                    <div
                      v-if="isMobileView && movieAndShowings.movie.name.length >= 15"
                      class="col-auto row justify-end items-center"
                    >
                      <template v-if="showShowingBadge && $_.some(showingBadges[movieAndShowings.movie.id].common, showingBadge => { return showingBadge.type !== 'name'})">
                        <showing-badge
                          v-for="showingBadge in $_.filter(showingBadges[movieAndShowings.movie.id].common, showingBadge => { return showingBadge.type !== 'name' })"
                          :key="showingBadge.id"
                          class="col-auto"
                          dense
                          outline
                          :color="widgetIncludeBannerBackground || showtimesUseDarkMode || showtimesBlocksTextLight ? 'grey-4' : 'secondary'"
                          size="md"
                          :showing-badge="showingBadge"
                          force-icon
                          clickable
                          @click="$emit('toggle-showing-badge', showingBadge.id)"
                        />
                      </template>
                      <rated
                        v-if="movieAndShowings.movie.rating"
                        :outline="false"
                        :color="'secondary'"
                        :text-color="'white'"
                        :rated="movieAndShowings.movie.rating"
                        :rating-reason="movieAndShowings.movie.ratingReason"
                        :size="'md'"
                        dense
                        :add-padding="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER"
                        class="q-px-md col"
                      />
                    </div>
                  </div>
                </div>
                <div
                  v-if="showMovieSynopsis"
                  class="col-12 q-pr-md "
                  :class="{
                    'text-white': showtimesUseDarkMode || widgetIncludeBannerBackground || showtimesBlocksTextLight,
                    'q-py-md': !isMobileView,
                    'q-pt-md': isMobileView
                  }"
                >
                  <!-- eslint-disable vue/no-v-html -->
                  <div
                    class="text-body1"
                    :class="movieAndShowings.movie.synopsisWithBreaks.length > 120 && movieSynopsisWrapped ? 'ellipsis-lines' : undefined"
                    :style="{ '-webkit-line-clamp': movieAndShowings.movie.synopsisWithBreaks.length > 120 && movieSynopsisWrapped ? isMobileView ? mobileTruncatedLineCount : truncatedLineCount : undefined }"
                    v-html="movieAndShowings.movie.synopsisWithBreaks"
                  />

                  <!-- eslint-enable vue/no-v-html -->
                </div>
              </div>
              <div
                v-for="([date, showingsForDate], i) in $_.entries(movieAndShowings.showings)"
                :key="i"
                class="text-center"
                :class="[$register && 'column', isCompactLayout || isMoviePage ? 'q-mb-xs' : 'q-mb-md', !isMobileView && 'q-pl-md']"
              >
                <div
                  v-if="showDateHeadings"
                  class="text-uppercase"
                  :class="{
                    'q-mt-lg q-ml-xs text-center': $register,
                    'text-h5': $register || isMoviePage,
                    'text-h6': !$register && !isMoviePage,
                    'text-left': !$register,
                    'q-my-sm': isMobileView,
                    'q-mb-sm': !isMobileView,
                    'text-white': (showtimesUseDarkMode || widgetIncludeBannerBackground || showtimesBlocksTextLight) && !isMoviePage && !$register
                  }"
                  style="z-index: 2;"
                >
                  <template
                    v-if="!showMultipleSites || $register"
                  >
                    <span
                      :class="(showtimesUseDarkMode || widgetIncludeBannerBackground || showtimesBlocksTextLight) && !isMoviePage && !$register ? 'text-grey-4' : 'text-primary'"
                    >
                      {{ getRelativeDateHeading(date)[0] }} </span> {{ getRelativeDateHeading(date)[1] }}
                  </template>
                  <template
                    v-else
                  >
                    <span
                      :class="(showtimesUseDarkMode || widgetIncludeBannerBackground || showtimesBlocksTextLight) && !isMoviePage && !$register ? 'text-grey-4' : 'text-primary'"
                    > {{ movieAndShowings.movie.site.name }}
                    </span>
                    <span
                      v-if="movieAndShowings && movieAndShowings.currentDistanceText"
                      :class="(showtimesUseDarkMode || widgetIncludeBannerBackground || showtimesBlocksTextLight) && !isMoviePage && !$register ? 'text-grey-4' : 'text-primary'"
                    >
                      {{ `(${movieAndShowings.currentDistanceText})` }}
                    </span>
                  </template>
                  <span
                    v-if="!$register && showShowingBadge"
                  >
                    <template
                      v-for="(showingBadge, index) in showingBadges[movieAndShowings.movie.id].commonForDate(showingsForDate[0])"
                      :key="showingBadge.id"
                    >
                      <template v-if="index > 0">&nbsp;&middot;&nbsp;</template>
                      <showing-badge
                        class="col-auto transparent q-pa-none q-mt-none"
                        :color="(widgetIncludeBannerBackground || showtimesUseDarkMode || showtimesBlocksTextLight) && !isMoviePage && !$register ? 'grey-4' : 'responsive'"
                        dense
                        :size="isMoviePage || $register ? 'md' : 'sm'"
                        :showing-badge="showingBadge"
                        clickable
                        @click="$emit('toggle-showing-badge', showingBadge.id)"
                      />
                    </template>
                  </span>
                </div>
                <div
                  class="showings col row"
                  :class="showingWrapperClasses"
                  :style="{
                    'align-content': $register || isMoviePage ? 'space-evenly' : undefined,
                    'min-width': $register || isMoviePage ? 'unset' : undefined,
                    'margin-left': useBanner && isMobileView ? '-4px' : undefined,
                    'margin-right': useBanner && isMobileView ? '-4px' : undefined
                  }"
                >
                  <div
                    v-for="showing in showingsForDate"
                    :key="showing.id"
                    data-test-id="showing-for-date-container"
                    :class="{
                      'column col-auto q-mx-md': !$q.screen.lt.md && !isPhonePreview && $register && !isCompactLayout,
                      ...(isCompactLayout ? {
                        'column col-auto': true,
                        'q-mr-md': !$q.screen.gt.md || isPhonePreview,
                        'q-mr-lg': $q.screen.gt.md && !isPhonePreview
                      } : {}),
                      'column col-auto': isMoviePage && (!$register || $q.screen.lt.md || isPhonePreview),
                      'col-6 q-px-xs q-pb-sm': showtimesListButtonType === SHOWTIMES_BUTTON_TYPES.DESCRIPTIVE && !isMoviePage && showtimesViewType === SHOWTIMES_VIEW_TYPES.BLOCK,
                      'col-6 q-px-xs q-pt-xs q-pb-sm': !isCompactLayout && showtimesListButtonType !== SHOWTIMES_BUTTON_TYPES.DESCRIPTIVE && !isMoviePage && showtimesViewType === SHOWTIMES_VIEW_TYPES.BLOCK,
                      'col-md-4': !isPhonePreview && !isMoviePage && !isCompactLayout,
                    }"

                    :style="{
                      width: showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER ? '27%' : undefined,
                      'margin-top': showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER ? '8px' : undefined,
                      'padding-inline': showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER ? '4px' : undefined,
                      'opacity': $register && showing.showingFinished ? '0.7' : undefined
                    }"
                  >
                    <div
                      v-if="$register"
                      class="text-caption q-mx-auto"
                      :style="{
                        'line-height': '1.6em',
                        'font-size': '11px',
                        'width': showtimesButonBasicWidth
                      }"
                    >
                      <div
                        v-if="showing.showingStarted && !showing.showingFinished"
                        class="text-white bg-secondary"
                        data-showing-started
                      >
                        {{ $t('movie.nowPlaying') }}
                      </div>
                      <div
                        v-else-if="showing.showingStartingSoon()"
                        class="text-white bg-primary"
                        data-showing-upcoming
                      >
                        {{ $t('time.startingSoon') }}
                      </div>
                      <!-- line-break for consistent spacing -->
                      <br v-else>
                    </div>
                    <showtimes-button-basic
                      v-if="showtimesListButtonType === SHOWTIMES_BUTTON_TYPES.BASIC || $register"
                      :showing="showing"
                      :is-disabled="disabled(showing)"
                      :is-movie-page="isMoviePage"
                      :border-radius="buttonBorderRadius"
                      :has-multiple-screens="multipleScreens(showing, showingsForDate)"
                      :compact="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER"
                      @select-showing="showing => $emit('select-showing', showing)"
                      @show-held-seat-dialog="showHeldSeatDialog(showing)"
                    />
                    <showtimes-button-descriptive
                      v-else-if="showtimesListButtonType === SHOWTIMES_BUTTON_TYPES.DESCRIPTIVE"
                      :showing="showing"
                      :show-attendance-levels="showAttendanceLevels"
                      :solid-showing-badges="solidShowingBadges"
                      :is-disabled="disabled(showing)"
                      :is-movie-page="isMoviePage"
                      :border-radius="buttonBorderRadius"
                      :showtimes-use-dark-mode="showtimesUseDarkMode || widgetIncludeBannerBackground"
                      :is-showtime-grid="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER"
                      :compact="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER"
                      :show-button-progress-bar="showButtonProgressBar"
                      :button-color="buttonColor"
                      :button-color-hex="buttonColorHex"
                      is-showing-button
                      @select-showing="showing => $emit('select-showing', showing)"
                      @show-held-seat-dialog="showHeldSeatDialog(showing)"
                    />
                    <showtimes-button-compact
                      v-else-if="showtimesListButtonType === SHOWTIMES_BUTTON_TYPES.COMPACT"
                      :showing="showing"
                      :show-attendance-levels="showAttendanceLevels"
                      :solid-showing-badges="solidShowingBadges"
                      :is-disabled="disabled(showing)"
                      :is-movie-page="isMoviePage"
                      :border-radius="buttonBorderRadius"
                      :distinct-showing-badges="showingBadges[movieAndShowings.movie.id].distinctForDate(showing)"
                      :button-type="buttonType"
                      :button-color="buttonColor"
                      :button-color-hex="buttonColorHex"
                      is-showing-button
                      @select-showing="showing => $emit('select-showing', showing)"
                      @show-held-seat-dialog="showHeldSeatDialog(showing)"
                    />
                    <template
                      v-if="$register || showButtonProgressBar"
                    >
                      <showtime-attendance-bar
                        :showing="showing"
                        style="z-index: 2;"
                        :style="{
                          width: ($register || showtimesListButtonType === SHOWTIMES_BUTTON_TYPES.BASIC) ? showtimesButonBasicWidth : undefined,
                          'border-radius': !$register && showtimesListButtonType !== SHOWTIMES_BUTTON_TYPES.BASIC && !isMoviePage ? '0 0' + `${borderRadius}px` + `${borderRadius}px` : undefined,
                          'box-shadow': showtimesListButtonType === SHOWTIMES_BUTTON_TYPES.COMPACT ? '0 0px 3px rgba(255, 255, 255, 0.4)' : undefined
                        }"
                        class="absolute"
                        :class="{
                          'q-mx-auto': showtimesListButtonType === SHOWTIMES_BUTTON_TYPES.BASIC || $register,
                          'attendance-bar': showtimesListButtonType !== SHOWTIMES_BUTTON_TYPES.BASIC && !$register,
                          'compact-button': showtimesListButtonType === SHOWTIMES_BUTTON_TYPES.COMPACT,
                          'slider-button': showtimesListButtonType !== SHOWTIMES_BUTTON_TYPES.BASIC && showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER
                        }"
                        @click="showHeldSeatDialog(showing)"
                      />
                      <q-tooltip
                        v-if="showButtonProgressBar && !$register"
                        :offset="[10, 10]"
                      >
                        {{ ticketLimitMessage(showing) }}
                      </q-tooltip>
                    </template>

                    <div
                      v-if="showtimesListButtonType === SHOWTIMES_BUTTON_TYPES.BASIC || $register"
                      data-test-id="showing-for-date-badges-container"
                      class="row justify-center items-center q-mt-sm q-mx-auto"
                      :style="{ ...(isCompactLayout ? { 'max-width': showtimesButonBasicWidth } : { 'max-width': $q.screen.lt.md || isPhonePreview ? '116px' : undefined }) }"
                      :class="{ 'q-mb-md': $register && !isCompactLayout }"
                      @click="showHeldSeatDialog(showing)"
                    >
                      <q-badge
                        v-if="$register"
                        class="q-mr-sm"
                        color="primary"
                        outline
                      >
                        {{ showing.ticketsSold || '0' }}
                        <q-tooltip
                          class="text-white"
                          style="background-color: rgba(0, 0, 0, 0.5)"
                        >
                          {{ $t('ticket.ticketsSold') }}
                        </q-tooltip>
                      </q-badge>
                      <q-badge
                        v-if="$register"
                        class="q-mr-sm"
                        style="padding: 3px 7px"
                        :color="availableColor(showing)"
                        data-test-id="showtimes-by-film-tickets-remaining-badge"
                      >
                        {{ showing.seatsRemaining || '0' }}
                        <q-tooltip
                          class="text-white"
                          style="background-color: rgba(0, 0, 0, 0.5)"
                        >
                          {{ $t('ticket.ticketsRemaining') }}
                        </q-tooltip>
                      </q-badge>
                      <template v-if="showtimesListButtonType === SHOWTIMES_BUTTON_TYPES.BASIC">
                        <showing-badge
                          v-for="showingBadge in showingBadges[movieAndShowings.movie.id].distinctForDate(showing)"
                          :key="showingBadge.id"
                          class="col-auto"
                          style="border: solid 1px;"
                          :class="!$register ? 'q-pa-sm q-pr-xs' : ''"
                          :outline="!showtimesUseDarkMode || !widgetIncludeBannerBackground "
                          :solid="solidShowingBadges"
                          size="sm"
                          :color="showingBadgeColor"
                          :showing-badge="showingBadge"
                          :display-title-on-button="showingBadge.displayTitleOnButton"
                          :dense="$register"
                          clickable
                          @click="$emit('toggle-showing-badge', showingBadge.id)"
                        />
                        <q-chip
                          v-if="!$register && showing.isSoldOut"
                          square
                          color="negative"
                          size="sm"
                          style="border: solid 1px;"
                          text-color="white"
                          :label="$t('status.soldOut')"
                        />
                        <q-chip
                          v-else-if="!$register && currentSite.showConsumerAttendanceBadge && showAttendanceLevels && (showing.predictedAttendance < 7 || showing.predictedAttendance > 20)"
                          square
                          :color="solidShowingBadges ? (showing.predictedAttendance > 20 ? 'negative' : 'positive') : 'transparent'"
                          :size="$register ? 'md' : 'sm'"
                          style="border: solid 1px;"
                          :text-color="solidShowingBadges ? 'white' : (showing.predictedAttendance > 20 ? 'negative' : 'positive')"
                        >
                          <q-icon
                            name="people"
                            :text-color="showing.predictedAttendance > 20 ? 'negative' : 'positive'"
                            class="q-chip__icon material-icons q-icon notranslate"
                          />
                          <q-tooltip
                            class="text-white"
                            style="background-color: rgba(0, 0, 0, 0.5)"
                          >
                            {{ showing.predictedAttendance > 20 ?
                              ('We are projecting a high turn out for this showing! Suggest arriving ' + Math.round(Math.max(showing.predictedAttendance / 3, 10)) + ' minutes before the start time.') :
                              'Low projected attendance level, this is a great show to attend, beat the crowds!'
                            }}
                          </q-tooltip>
                        </q-chip>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </component>
        <q-inner-loading :showing="loading || (showingsQuery.loading && !reloading)" />
        <template v-if="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER && sliderPaginationVisible">
          <div
            class="swiper-pagination swiper-pagination-bullets"
            :class="'swiper-pagination-' + id + ' ' + (showtimesUseDarkMode || widgetIncludeBannerBackground ? 'text-white' : 'text-primary')"
          />
        </template>
        <template v-if="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER && sliderControlsVisible">
          <div
            class="swiper-button-prev q-pa-md text-white"
            :class="'swiper-button-prev-' + id"
            style="left: 0; text-shadow: 0 0 3px rgba(0, 0, 0, 0.5);"
          />
          <div
            class="swiper-button-next q-pa-md text-white"
            :class="'swiper-button-next-' + id"
            style="right: 0; text-shadow: 0 0 3px rgba(0, 0, 0, 0.5);"
          />
        </template>
      </component>
    </div>
    <div
      v-else
    >
      <div
        v-for="([date, moviesAndShowings], i) in $_.entries(showingsByDateAndMovie)"
        :key="i"
        class="container q-mt-md"
      >
        <div
          v-if="showDateHeadings"
          class="text-uppercase"
          :class="$q.screen.lt.md || isPhonePreview ? 'text-h6 text-left q-my-xs' : $register || isMoviePage ? 'text-h5' : 'text-h6 text-left'"
          :style="{
            color: showtimesUseDarkMode ? '#fff' : '#777',
            'padding-left': showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER || ($q.screen.gt.sm && !isPhonePreview) ? undefined : `${sliderGutter}px`,
            'padding-right': showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER || ($q.screen.gt.sm && !isPhonePreview) ? undefined : `${sliderGutter}px`
          }"
        >
          <span
            :class="showtimesUseDarkMode ? 'text-grey-4' : 'text-primary'"
          >
            {{ getRelativeDateHeading(date)[0] }} </span> {{ getRelativeDateHeading(date)[1] }}
        </div>

        <component
          :is="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER ? 'swiper' : 'div'"
          :key="changeCount"
          class="poster-list"
          :class=" showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER ? '' : 'row'"
          :style="{
            'padding-bottom': showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER ? '50px' : undefined,
            'margin-left': showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER || isMobileView ? undefined : `-${sliderGutter}px`,
            'margin-right': showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER || isMobileView ? undefined : `-${sliderGutter}px`
          }"
          :slides-per-view="sliderPerView"
          :space-between="sliderGutter"
          :auto-height="!showtimesGridButtonUseButtonDrawer"
          :breakpoints="isPhonePreview ? undefined : breakPoints"
          preload-images
          allow-touch-move
          center-insufficient-slides
          :modules="[Navigation, Pagination, Autoplay]"
          :navigation="{
            nextEl: `.swiper-button-next-${id}`,
            prevEl: `.swiper-button-pre-${id}`
          }"
          :pagination="{
            el: `.swiper-pagination-${id}`,
            type: 'bullets',
            clickable: true
          }"
          :autoplay="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER && sliderAutoplay ? showtimeAutoplay : false"
        >
          <component
            :is="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER ? 'swiper-slide' : 'div'"
            v-for="movieAndShowings in moviesAndShowings"
            :key="movieAndShowings.movie.id"
            :class="{
              [gridClass]: true,
              'q-my-sm': showtimesViewType !== SHOWTIMES_VIEW_TYPES.SLIDER,
              'q-pa-xs': showtimesViewType !== SHOWTIMES_VIEW_TYPES.SLIDER && !isPhonePreview,
              'full-height': showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER,
              [movieAndShowings.movie.displayMetaData && movieAndShowings.movie.displayMetaData.classes]: true
            }"
            :style="{ padding: showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER ? undefined : `0 ${sliderGutter}px` }"
            class="cursor-pointer"
          >
            <div
              class="relative-position full-height"
              :class="{ ['bg-' + `${showtimesBlocksBackgroundColor}`]: showtimesBlocksBackgroundColor !== 'custom' && showtimesBlocksBackgroundColor !== null }"
              :style="{
                'background-color': showtimesBlocksBackgroundColor === 'custom' ? showtimesBlocksBackgroundColorHex : undefined,
                'border-radius': `${borderRadius}px`
              }"
            >
              <div
                class="poster-image-container bg-dark relative-position"
                :class="('shadow-' + shadow)"
                :style=" {
                  height: useBanner ? cleanImage && enableLeavingSoonBanner && movieAndShowings.movie.displayMetaData.classes.includes('leaves-soon') ? '185px' : '165px' : undefined,
                  'padding-bottom': useBanner && cleanImage && enableLeavingSoonBanner && movieAndShowings.movie.displayMetaData.classes.includes('leaves-soon') ? '20px' : undefined,
                  'border-radius': isMoviePage ? undefined : `${borderRadius}px`
                }"
                @click="$emit('select-movie', movieAndShowings.movie)"
              >
                <span
                  v-if="showClass && movieAndShowings.movie.titleClass"
                  class="q-ma-sm q-px-sm bg-primary text-white absolute-top-right shadow-6 text-weight-bold"
                  :class="$_.kebabCase(movieAndShowings.movie.titleClass.name)"
                  :style="'border-radius: ' + borderRadius + 'px;'"
                  style="z-index: 2"
                >{{ movieAndShowings.movie.titleClass.name }}
                </span>
                <q-btn
                  v-if="movieAndShowings.movie.trailerYoutubeId && showTrailerButton"
                  square
                  color="primary"
                  size="sm"
                  padding="sm"
                  class="watch-trailer-btn absolute-top-left shadow-6 row"
                  icon="play_arrow"
                  style="z-index: 2"
                  :style="{ 'border-radius': `${borderRadius}px` }"
                  @click.stop="$emit('play-trailer', movieAndShowings.movie.trailerYoutubeId); $trackEvent($customerEvents.MOVIE_PAGE_TRAILER_BUTTON, movieAndShowings.movie.trackingData)"
                />
                <q-img
                  v-if="!useBanner"
                  :ratio="2/3"
                  :src="movieAndShowings.movie.posterImageUrl"
                  class="full-width"
                />
                <q-img
                  v-else
                  class="full-height"
                  :src="movieAndShowings.movie.bannerImageUrl"
                />
                <q-badge
                  v-if="enableLeavingSoonBanner && movieAndShowings.movie.displayMetaData.classes.includes('leaves-soon')"
                  class=" text-white text-weight-bold  justify-center full-width inset-shadow bg-negative"
                  :class="{ 'absolute-bottom': !cleanImage }"
                  style="line-height: auto; min-height: auto; border-radius: 0; padding: 5px; z-index: 2;"
                >
                  <template
                    v-if="movieAndShowings.movie.displayMetaData.classes.includes('leaves-soon')"
                  >
                    <template
                      v-if="movieAndShowings.movie.displayMetaData.classes.includes('last-day-tomorrow')"
                    >
                      {{ $t('time.endsTomorrow') }}
                    </template>
                    <template
                      v-else-if="movieAndShowings.movie.displayMetaData.classes.includes('last-day-today')"
                    >
                      {{ $t('time.endsToday') }}
                    </template>
                    <template
                      v-else
                    >
                      {{ $t('time.leavesSoon') }}
                    </template>
                  </template>
                </q-badge>
              </div>
              <div
                :class=" {
                  'banner-info q-mt-sm': cleanImage,
                  'poster-info text-white absolute full-width column justify-end q-mb-sm': !cleanImage,
                  'text-white': showtimesUseDarkMode || showtimesBlocksTextLight,
                  'leaves-soon q-pb-md': !cleanImage && enableLeavingSoonBanner && movieAndShowings.movie.displayMetaData.classes.includes('leaves-soon'),
                  'q-px-sm': showtimesBlocksBackgroundColor !== null && cleanImage
                }"
                :style="{
                  'border-radius': `${borderRadius}px`,
                  'min-height': cleanImage ?`${maxBannerHeight}px` : undefined
                }"
                @click="$emit('select-movie', movieAndShowings.movie)"
              >
                <div
                  class="row"
                  :class="{ 'q-pt-xl q-px-sm q-pb-sm': !cleanImage }"
                >
                  <div class="col">
                    <div
                      v-if="showShowingBadge && (!!showingBadges[movieAndShowings.movie.id].commonForDate(movieAndShowings.showings[0]) && $_.some(showingBadges[movieAndShowings.movie.id].commonForDate(movieAndShowings.showings[0]), showingBadge => { return showingBadge.type === 'name'}))"
                      class="poster-subtitle row"
                      :class="{ 'no-wrap': cleanImage }"
                    >
                      <showing-badge
                        v-for="showingBadge in $_.filter(showingBadges[movieAndShowings.movie.id].commonForDate(movieAndShowings.showings[0]), showingBadge => { return showingBadge.type === 'name'})"
                        :key="showingBadge.id"
                        class="col-auto q-my-none q-mt-xs"
                        :class="cleanImage && !showtimesBlocksTextLight ? 'text-dark' : 'text-grey-4'"
                        :color="showtimesBlocksTextLight || showtimesUseDarkMode || !cleanImage ? 'grey-4' : 'secondary'"
                        style="margin-left: 0;"
                        size="md"
                        outline
                        dense
                        :showing-badge="showingBadge"
                        clickable
                        @click="$emit('toggle-showing-badge', showingBadge.id)"
                      />
                    </div>
                    <div class="row justify-between items-center">
                      <div
                        class="poster-title text-weight-bold text-uppercase col-auto"
                        :class="{ 'q-mt-xs': showShowingBadge && !!showingBadges[movieAndShowings.movie.id].commonForDate(movieAndShowings.showings[0]) && showingBadges[movieAndShowings.movie.id].commonForDate(movieAndShowings.showings[0]).length > 0 }"
                      >
                        {{ movieAndShowings.movie.name }}
                      </div>
                      <div
                        v-if="movieAndShowings.movie.name && movieAndShowings.movie.name.length < 15"
                        class="col-auto q-mt-xs row justify-end items-center"
                      >
                        <template
                          v-if="showShowingBadge && (!!showingBadges[movieAndShowings.movie.id].commonForDate(movieAndShowings.showings[0]) && $_.some(showingBadges[movieAndShowings.movie.id].commonForDate(movieAndShowings.showings[0]), showingBadge => { return showingBadge.type !== 'name'}))"
                        >
                          <showing-badge
                            v-for="showingBadge in $_.filter(showingBadges[movieAndShowings.movie.id].commonForDate(movieAndShowings.showings[0]), showingBadge => { return showingBadge.type !== 'name'})"
                            :key="showingBadge.id"
                            class="col-auto q-ml-none q-mr-xs"
                            :class="cleanImage && !showtimesBlocksTextLight ? 'text-secondary' : 'text-grey-4'"
                            :color="showtimesBlocksTextLight || showtimesUseDarkMode || !cleanImage ? 'grey-4' : 'secondary'"
                            size="md"
                            outline
                            dense
                            force-icon
                            :showing-badge="showingBadge"
                            clickable
                            @click="$emit('toggle-showing-badge', showingBadge.id)"
                          />
                        </template>

                        <rated
                          v-if="movieAndShowings.movie.rating"
                          :outline="false"
                          :color="'secondary'"
                          :text-color="'white'"
                          :rated="movieAndShowings.movie.rating"
                          :rating-reason="movieAndShowings.movie.ratingReason"
                          dense
                          :size="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER && !isNARegion ? 'sm' : 'md'"
                          class="q-ml-none q-px-sm col"
                          :add-padding="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER"
                        />
                      </div>
                    </div>
                    <div class="row justify-between items-center">
                      <div class="col-auto">
                        <template
                          v-if="movieAndShowings.movie.formattedDuration"
                        >
                          {{ movieAndShowings.movie.formattedDuration }}
                        </template>
                        <template v-if="movieAndShowings.movie.formattedDuration && movieAndShowings.movie.genre">
                          &nbsp;&middot;&nbsp;
                        </template>
                        <template
                          v-if="movieAndShowings.movie.genre"
                        >
                          {{ movieAndShowings.movie.genre }}
                        </template>
                      </div>
                      <div
                        v-if="movieAndShowings.movie.name && movieAndShowings.movie.name.length >= 15"
                        class="row col-auto q-mt-xs justify-end items-center"
                      >
                        <template
                          v-if="showShowingBadge && (!!showingBadges[movieAndShowings.movie.id].commonForDate(movieAndShowings.showings[0]) && $_.some(showingBadges[movieAndShowings.movie.id].commonForDate(movieAndShowings.showings[0]), showingBadge => { return showingBadge.type !== 'name'}))"
                        >
                          <showing-badge
                            v-for="showingBadge in $_.filter(showingBadges[movieAndShowings.movie.id].commonForDate(movieAndShowings.showings[0]), showingBadge => { return showingBadge.type !== 'name'})"
                            :key="showingBadge.id"
                            class="col-auto q-ml-none q-mr-xs"
                            :class="cleanImage && !showtimesBlocksTextLight ? 'text-dark' : 'text-grey-4'"
                            :color="showtimesBlocksTextLight || showtimesUseDarkMode || !cleanImage ? 'grey-4' : 'secondary'"
                            size="md"
                            outline
                            dense
                            force-icon
                            :showing-badge="showingBadge"
                            clickable
                            @click="$emit('toggle-showing-badge', showingBadge.id)"
                          />
                        </template>

                        <rated
                          v-if="movieAndShowings.movie.rating"
                          :outline="false"
                          :color="'secondary'"
                          :text-color="'white'"
                          :rated="movieAndShowings.movie.rating"
                          :rating-reason="movieAndShowings.movie.ratingReason"
                          dense
                          :size="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER && !isNARegion ? 'sm' : 'md'"
                          class="q-ml-none q-px-sm col"
                          :add-padding="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="!$register && showtimesGridButtonType === SHOWTIMES_BUTTON_TYPES.COMPACT && showtimesGridButtonUseButtonDrawer"
                :class="{
                  'q-pa-sm': showtimesBlocksBackgroundColor !== null,
                  'q-mt-sm': !cleanImage
                }"
              >
                <q-btn
                  class="q-btn text-weight-bold toggle-btn full-width q-mt-xs"
                  :color="buttonColor !== 'custom' && filledButton ? buttonColor : undefined"
                  :text-color="!filledButton && buttonColor !== 'custom' ? buttonColor : undefined"
                  :outline="buttonType === BUTTON_TYPES.OUTLINE"
                  :flat="buttonType === BUTTON_TYPES.FLAT"
                  :unelevated="buttonType === BUTTON_TYPES.UNELEVATED"
                  :class="{ active: selectedMovieId === movieAndShowings.movie.id }"
                  :style="{
                    'border-radius': `${buttonBorderRadius}px`,
                    'background-color': filledButton && buttonColor === 'custom' ? buttonColorHex : undefined,
                    color: !filledButton && buttonColor === 'custom' ? buttonColorHex : undefined
                  }"
                  padding="md 0"
                  @click.stop="showTimeslots(movieAndShowings.movie.id)"
                >
                  {{ $tc('ticket.actions.book', 2) }}
                </q-btn>
                <div
                  v-if="selectedMovieId === movieAndShowings.movie.id"
                  class="justify-between items-center text-weight-bold"
                  :class="{ [`bg-${buttonColor}`]: filledButton && buttonColor !== 'custom' }"
                  style="overflow: hidden; box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 5px inset;"
                  :style="{
                    'border-bottom-right-radius': `${buttonBorderRadius}px`,
                    'border-bottom-left-radius': `${buttonBorderRadius}px`,
                    'background-color': filledButton && buttonColor === 'custom' ? buttonColorHex : undefined,
                    'border': buttonType === BUTTON_TYPES.OUTLINE ? buttonColor === 'custom' ? `1px solid ${buttonColorHex}` : `1px solid var(--q-${buttonColor})`: undefined
                  }"
                >
                  <div
                    v-for="(showing, index) in movieAndShowings.showings"
                    :key="showing.id"
                  >
                    <showtimes-button-compact
                      :showing="showing"
                      :show-attendance-levels="showAttendanceLevels"
                      :solid-showing-badges="solidShowingBadges"
                      :is-disabled="disabled(showing)"
                      :is-movie-page="isMoviePage"
                      :is-showtime-grid="true"
                      :showtimes-grid-button-use-button-drawer="true"
                      :border-radius="buttonBorderRadius"
                      :distinct-showing-badges="showingBadges[movieAndShowings.movie.id].distinctForDate(showing)"
                      :button-type="buttonType"
                      :button-color="buttonColor"
                      :button-color-hex="buttonColorHex"
                      :add-inset-shadow="index === 0"
                      is-showing-button
                      @select-showing="showing => $emit('select-showing', showing)"
                      @show-held-seat-dialog="showHeldSeatDialog(showing)"
                    />
                    <template
                      v-if="$register || showButtonProgressBarInGridView"
                    >
                      <showtime-attendance-bar
                        :showing="showing"
                        style="z-index: 2;box-shadow: 0 0px 3px rgba(255, 255, 255, 0.4); border-radius: 6px; margin-right: 2px; margin-left: 2px; margin-bottom: 2px;"
                        class="absolute attendance-bar drawner-style"

                        @click="showHeldSeatDialog(showing)"
                      />
                      <q-tooltip
                        v-if="showButtonProgressBar && !$register"
                        :offset="[10, 10]"
                      >
                        {{ ticketLimitMessage(showing) }}
                      </q-tooltip>
                    </template>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="row q-col-gutter-xs"
                :class="{
                  'q-pb-sm q-mx-xs': !!showtimesBlocksBackgroundColor,
                  'q-mt-sm': !cleanImage,
                  'q-mt-xs': cleanImage
                }"
              >
                <div
                  v-for="showing in movieAndShowings.showings"
                  :key="showing.id"
                  :class="{
                    'q-mx-md': $register,
                    'col-6': showtimesViewType === SHOWTIMES_VIEW_TYPES.BLOCK
                  }"
                  :style="{ width: showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER ? '32%' : undefined }"
                >
                  <showtimes-button-basic
                    v-if="showtimesGridButtonType === SHOWTIMES_BUTTON_TYPES.BASIC || $register"
                    :showing="showing"
                    :is-disabled="disabled(showing)"
                    :is-showtime-grid="true"
                    :border-radius="buttonBorderRadius"
                    :has-multiple-screens="multipleScreens(showing, movieAndShowings.showings)"
                    :compact="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER"
                    @select-showing="showing => $emit('select-showing', showing)"
                    @show-held-seat-dialog="showHeldSeatDialog(showing)"
                  />
                  <showtimes-button-descriptive
                    v-else-if="showtimesGridButtonType === SHOWTIMES_BUTTON_TYPES.DESCRIPTIVE"
                    :showing="showing"
                    :show-attendance-levels="showAttendanceLevels"
                    :solid-showing-badges="solidShowingBadges"
                    :is-disabled="disabled(showing)"
                    :is-movie-page="isMoviePage"
                    :is-showtime-grid="true"
                    :border-radius="buttonBorderRadius"
                    :compact="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER"
                    :showtimes-use-dark-mode="showtimesUseDarkMode || showtimesBlocksTextLight"
                    :show-button-progress-bar="showButtonProgressBarInGridView"
                    :button-color="buttonColor"
                    :button-color-hex="buttonColorHex"
                    is-showing-button
                    @select-showing="showing => $emit('select-showing', showing)"
                    @show-held-seat-dialog="showHeldSeatDialog(showing)"
                  />
                  <showtimes-button-compact
                    v-else-if="showtimesGridButtonType === SHOWTIMES_BUTTON_TYPES.COMPACT"
                    :showing="showing"
                    :show-attendance-levels="showAttendanceLevels"
                    :solid-showing-badges="solidShowingBadges"
                    :is-disabled="disabled(showing)"
                    :is-movie-page="isMoviePage"
                    :is-showtime-grid="true"
                    :compact="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER"
                    :border-radius="buttonBorderRadius"
                    :button-color="buttonColor"
                    :button-color-hex="buttonColorHex"
                    :button-type="buttonType"
                    :distinct-showing-badges="showingBadges[movieAndShowings.movie.id].distinctForDate(showing)"
                    is-showing-button
                    @select-showing="showing => $emit('select-showing', showing)"
                    @show-held-seat-dialog="showHeldSeatDialog(showing)"
                  />
                  <template
                    v-if="$register || showButtonProgressBarInGridView"
                  >
                    <showtime-attendance-bar
                      :showing="showing"
                      style="z-index: 2;"
                      :style="showtimesGridButtonType === SHOWTIMES_BUTTON_TYPES.BASIC ? '' : (showtimesGridButtonType === SHOWTIMES_BUTTON_TYPES.COMPACT? 'box-shadow: 0 0px 3px rgba(255, 255, 255, 0.4);' : '') + 'border-radius: 0 0 ' + borderRadius + 'px ' + borderRadius + 'px;'"
                      class="absolute"
                      :class="{
                        'attendance-bar': showtimesListButtonType !== SHOWTIMES_BUTTON_TYPES.BASIC && !$register,
                        'compact-button': showtimesListButtonType === SHOWTIMES_BUTTON_TYPES.COMPACT,
                        'slider-button': showtimesListButtonType !== SHOWTIMES_BUTTON_TYPES.BASIC && showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER
                      }"
                      @click="showHeldSeatDialog(showing)"
                    />
                    <q-tooltip
                      v-if="showButtonProgressBarInGridView && !$register"
                      :offset="[10, 10]"
                    >
                      {{ ticketLimitMessage(showing) }}
                    </q-tooltip>
                  </template>

                  <div
                    class="row justify-center items-center"
                    :class="showtimesDisplayType === SHOWTIMES_DISPLAY_TYPES.LIST ? 'q-mt-sm' : 'q-mt-none'"
                    @click="showHeldSeatDialog(showing)"
                  >
                    <q-badge
                      v-if="$register"
                      class="q-mr-sm"
                      color="primary"
                      outline
                    >
                      {{ showing.ticketsSold || '0' }}
                      <q-tooltip
                        class="text-white"
                        style="background-color: rgba(0, 0, 0, 0.5)"
                      >
                        {{ $t('ticket.ticketsSold') }}
                      </q-tooltip>
                    </q-badge>
                    <q-badge
                      v-if="$register"
                      class="q-mr-sm"
                      style="padding: 3px 7px"
                      :color="availableColor(showing)"
                    >
                      {{ showing.seatsRemaining || '0' }}
                      <q-tooltip
                        class="text-white"
                        style="background-color: rgba(0, 0, 0, 0.5)"
                      >
                        {{ $t('ticket.ticketsRemaining') }}
                      </q-tooltip>
                    </q-badge>
                    <template v-if="showtimesGridButtonType === SHOWTIMES_BUTTON_TYPES.BASIC">
                      <showing-badge
                        v-for="showingBadge in showingBadges[movieAndShowings.movie.id].distinctForDate(showing)"
                        :key="showingBadge.id"
                        class="col-auto"
                        style="border: solid 1px;"
                        :class="{ 'q-pa-sm q-pr-xs': !$register }"
                        :outline="$register || !widgetIncludeBannerBackground"
                        :solid="solidShowingBadges"
                        size="sm"
                        :color="showingBadgeColor"
                        :showing-badge="showingBadge"
                        :display-title-on-button="showingBadge.displayTitleOnButton"
                        :dense="$register"
                        clickable
                        @click="$emit('toggle-showing-badge', showingBadge.id)"
                      />
                      <q-chip
                        v-if="!$register && showing.isSoldOut"
                        square
                        color="transparent"
                        :size="$register ? 'md' : 'sm'"
                        style="border: solid 1px;"
                        text-color="negative"
                        icon="people"
                        :label="$t('status.soldOut')"
                      />
                      <q-chip
                        v-else-if="!$register && currentSite.showConsumerAttendanceBadge && showAttendanceLevels && (showing.predictedAttendance < 7 || showing.predictedAttendance > 20)"
                        square
                        :color="solidShowingBadges ? (showing.predictedAttendance > 20 ? 'negative' : 'positive') : 'transparent'"
                        :size="$register ? 'md' : 'sm'"
                        style="border: solid 1px;"
                        :text-color="solidShowingBadges ? 'white' : (showing.predictedAttendance > 20 ? 'negative' : 'positive')"
                      >
                        <q-icon
                          name="people"
                          :text-color="showing.predictedAttendance > 20 ? 'negative' : 'positive'"
                          class="q-chip__icon material-icons q-icon notranslate"
                        />
                        <q-tooltip
                          class="text-white"
                          style="background-color: rgba(0, 0, 0, 0.5)"
                        >
                          {{ showing.predictedAttendance > 20 ?
                            ('We are projecting a high turn out for this showing! Suggest arriving ' + Math.round(Math.max(showing.predictedAttendance / 3, 10)) + ' minutes before the start time.') :
                            'Low projected attendance level, this is a great show to attend, beat the crowds!'
                          }}
                        </q-tooltip>
                      </q-chip>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </component>

          <template v-if="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER && sliderPaginationVisible">
            <div
              class="swiper-pagination"
              :class="'swiper-pagination-' + id + ' ' + (showtimesUseDarkMode ? 'text-white' : 'text-primary')"
            />
          </template>
          <template v-if="showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER && sliderControlsVisible">
            <div
              class="swiper-button-prev q-pa-md text-white"
              :class="'swiper-button-prev-' + id"
              style="left: 0; text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);"
            />
            <div
              class="swiper-button-next q-pa-md text-white"
              :class="'swiper-button-next-' + id"
              style="right: 0; text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);"
            />
          </template>
        </component>

        <q-inner-loading :showing="showingsQuery.loading && !reloading" />
      </div>
    </div>
  </div>
</template>

<script>
import { date, scroll } from 'quasar'
import { geoapifyEnabled, isNARegion } from 'src/config'
const { formatDate, addToDate } = date
import { BUTTON_TYPES, SHOWTIMES_BUTTON_TYPES, SHOWTIMES_DISPLAY_TYPES, SHOWTIMES_VIEW_TYPES } from 'src/models/page/Section'
import ShowingBadge from 'src/modules/admin/showing-badge/components/ShowingBadge'
import SwiperModulesMixin from 'src/modules/consumer/components/mixins/SwiperModulesMixin'
import Rated from 'src/modules/consumer/components/Rated'
import ShowtimeAttendanceBar from 'src/modules/consumer/components/ShowtimeAttendanceBar'
import ShowtimesButtonBasic from 'src/modules/consumer/components/ShowtimesButtonBasic'
import ShowtimesButtonCompact from 'src/modules/consumer/components/ShowtimesButtonCompact'
import ShowtimesButtonDescriptive from 'src/modules/consumer/components/ShowtimesButtonDescriptive'
import UseCurrentLocationButton from 'src/modules/consumer/components/site-selector/UseCurrentLocationButton'
export default {
  name: 'ShowtimesByFilm',
  components: {
    Rated,
    ShowingBadge,
    ShowtimeAttendanceBar,
    ShowtimesButtonBasic,
    ShowtimesButtonDescriptive,
    ShowtimesButtonCompact,
    UseCurrentLocationButton
  },
  configuration: ['sites', 'currentSite'],
  mixins: [SwiperModulesMixin],
  props: {
    id: {
      type: Number,
      required: false,
      default: 0
    },
    moviesAndShowingsByDate: {
      type: Array,
      required: false,
      default: () => []
    },
    showMultipleSites: {
      type: Boolean,
      required: false,
      default: false
    },
    shown: {
      type: Boolean,
      required: false,
      default: true
    },
    showingsByDateAndMovie: {
      type: Object,
      required: false,
      default: () => ({})
    },
    showingsQuery: {
      type: Object,
      required: true
    },
    allMovies: {
      type: Boolean,
      required: true
    },
    bannerBackground: {
      type: Boolean,
      required: false,
      default: true
    },
    bannerBrightness: {
      type: Number,
      required: false,
      default: 0.3
    },
    bannerOpacity: {
      type: Number,
      required: false,
      default: 0.8
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    },
    solidShowingBadges: {
      type: Boolean,
      required: false,
      default: false
    },
    showAttendanceLevels: {
      type: Boolean,
      required: false,
      default: true
    },
    usePredictedAttendance: {
      type: Boolean,
      required: false,
      default: false
    },
    allowPastShows: {
      type: Boolean,
      required: false,
      default: false
    },
    reloading: {
      type: Boolean,
      required: false,
      default: false
    },
    showtimesViewType: {
      type: String,
      required: false,
      default: SHOWTIMES_VIEW_TYPES.BLOCK
    },
    sliderControlsVisible: {
      type: Boolean,
      required: false,
      default: true
    },
    sliderPaginationVisible: {
      type: Boolean,
      required: false,
      default: true
    },
    sliderAutoplay: {
      type: Boolean,
      required: false,
      default: false
    },
    sliderPaginateGroupedSlides: {
      type: Boolean,
      required: false,
      default: false
    },
    sliderDelayInSeconds: {
      type: Number,
      required: false,
      default: 6
    },
    sliderGutter: {
      type: Number,
      required: false,
      default: 4
    },
    showtimesDisplayType: {
      type: String,
      required: false,
      default: 'list'
    },
    showtimesListButtonType: {
      type: String,
      required: false,
      default: SHOWTIMES_BUTTON_TYPES.BASIC
    },
    showtimesGridButtonType: {
      type: String,
      required: false,
      default: SHOWTIMES_BUTTON_TYPES.COMPACT
    },
    showtimesGridButtonUseButtonDrawer: {
      type: Boolean,
      required: false,
      default: false
    },
    showtimesUseDarkMode: {
      type: Boolean,
      required: false,
      default: false
    },
    isMoviePage: {
      type: Boolean,
      required: false,
      default: false
    },
    showButtonProgressBar: {
      type: Boolean,
      required: false,
      default: false
    },
    showButtonProgressBarInGridView: {
      type: Boolean,
      required: false,
      default: false
    },
    useBanner: {
      type: Boolean,
      required: false,
      default: false
    },
    cleanImage: {
      type: Boolean,
      required: false,
      default: false
    },
    borderRadius: {
      type: Number,
      required: false,
      default: 0
    },
    shadow: {
      type: Number,
      required: false,
      default: 0
    },
    showClass: {
      type: Boolean,
      required: false,
      default: false
    },
    showDateHeadings: {
      type: Boolean,
      required: false,
      display: false
    },
    showTrailerButton: {
      type: Boolean,
      required: false,
      default: false
    },
    enableLeavingSoonBanner: {
      type: Boolean,
      required: false,
      default: false
    },
    isNextShowingsAvailable: {
      type: Boolean,
      required: false,
      default: true
    },
    isFiltered: {
      type: Boolean,
      required: false,
      default: false
    },
    isPhonePreview: {
      type: Boolean,
      required: false,
      default: false
    },
    isMobileView: {
      type: Boolean,
      required: false,
      default: false
    },
    showtimesBlocksBackgroundColor: {
      type: String,
      required: false,
      default: null
    },
    showtimesBlocksBackgroundColorHex: {
      type: String,
      required: false,
      default: '#ffffff'
    },
    showtimesBlocksTextLight: {
      type: Boolean,
      required: false,
      default: false
    },
    showMovieImage: {
      type: Boolean,
      required: false,
      default: true
    },
    showMovieSynopsis: {
      type: Boolean,
      required: false,
      default: true
    },
    movieSynopsisWrapped: {
      type: Boolean,
      required: false,
      default: true
    },
    truncatedLineCount: {
      type: Number,
      required: false,
      default: 9
    },
    mobileTruncatedLineCount: {
      type: Number,
      required: false,
      default: 3
    },
    showShowingBadge: {
      type: Boolean,
      required: false,
      default: true
    },
    gridPerRow: {
      type: Number,
      required: false,
      default: 4
    },
    sliderPerView: {
      type: Number,
      required: false,
      default: 3
    },
    buttonType: {
      type: String,
      required: false,
      default: BUTTON_TYPES.UNELEVATED
    },
    buttonColor: {
      type: String,
      required: false,
      default: 'primary'
    },
    buttonColorHex: {
      type: String,
      required: false,
      default: '#ffffff'
    },
    buttonBorderRadius: {
      type: Number,
      required: false,
      default: 4
    }
  },
  emits: ['view-next-showings', 'clear-filters', 'select-movie', 'play-trailer', 'toggle-showing-badge', 'select-showing', 'common-showing-badges', 'edit-held-seats'],
  data () {
    return {
      didAutoScrollShowings: false,
      selectedMovieId: null,
      changeCount: 0,
      maxBannerHeight: null,
      mapsService: null,
      closestLocations: [],
      loading: false,
      maxSynopsisLineClampCounts: {}
    }
  },
  computed: {
    swiperOptions () {
      if (this.$register && this.allMovies) return
      if (this.showtimesViewType !== SHOWTIMES_VIEW_TYPES.SLIDER) return
      return {
        modules: [this.Navigation, this.Pagination, this.Autoplay],
        navigation: {
          nextEl: `.swiper-button-next-${this.id}`,
          prevEl: `.swiper-button-prev-${this.id}`
        },
        pagination: {
          el: `.swiper-pagination-${this.id}`,
          type: 'bullets',
          clickable: true
        },
        autoplay:
        this.showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER && this.sliderAutoplay
          ? this.showtimeAutoplay
          : false,
        loop: this.moviesAndShowingsByDate.length > 1,
        slidesPerView: 1,
        autoHeight: true,
        preloadImages: true,
        allowTouchMove: true,
        centerInsufficientSlides: true
      }
    },
    isCompactLayout () {
      return this.compact && this.$register
    },
    showtimesButonBasicWidth () {
      // Should match width inside ShowtimesButtonBasic
      return this.$q.screen.lt.md || this.isPhonePreview ? '102px' : '116px'
    },
    shouldShowAttendanceIcons () {
      return !this.$register && this.currentSite.showConsumerAttendanceBadge && this.showAttendanceLevels
    },
    bannerStyle () {
      return `opacity: ${this.bannerOpacity}; filter: brightness(${this.bannerBrightness});`
    },
    gridClass () {
      if (this.showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER) return

      if (this.isPhonePreview) return 'col-12'

      if (this.gridPerRow === 2) return 'col-12 col-sm-6'

      if (this.gridPerRow === 3) return 'col-12 col-sm-6 col-md-4'

      if (this.gridPerRow === 4) return 'col-12 col-sm-4 col-md-3'

      if (this.gridPerRow === 5) return 'col-12 col-sm-4 col-md-3 width-lg-20percent'

      if (this.gridPerRow === 6) return 'col-12 col-sm-4 col-md-3 col-lg-2'

      return 'col-12 col-sm-3 col-md-4'
    },
    showingBadges () {
      const showingBadgesByMovieId = {}

      _.each(this.moviesAndShowingsByDate, movieAndShowings => {
        const all = this.getAllShowingBadges(movieAndShowings.allShowings)
        const allForDate = (showing) => this.getShowingBadgesForDate(movieAndShowings.showings, showing)
        const common = this.getCommonShowingBadges(all, movieAndShowings.allShowings)
        this.$emit('common-showing-badges', common)
        const commonForDate = (showing) => this.getCommonShowingBadgesForDate(movieAndShowings.showings, showing)
        const distinctForDate = (showing) => this.getDistinctShowingBadgesForDate(movieAndShowings.showings, showing)
        showingBadgesByMovieId[movieAndShowings.movie.id] = {
          all,
          allForDate,
          common,
          commonForDate,
          distinctForDate
        }
      })

      return showingBadgesByMovieId
    },
    showingBadgeColor  () {
      if (this.isMoviePage || this.$register) {
        return this.$q.dark.isActive ? 'white' : 'black'
      } else {
        return this.showtimesUseDarkMode || this.widgetIncludeBannerBackground || this.showtimesBlocksTextLight ? 'white' : 'black'
      }
    },
    breakPoints () {
      if (this.sliderPaginateGroupedSlides) {
        return {
          300: { slidesPerView: 1, slidesPerGroup: 1 },
          640: { slidesPerView: 1, slidesPerGroup: 1 },
          768: { slidesPerView: 2, slidesPerGroup: 2 },
          1024: { slidesPerView: this.sliderPerView, slidesPerGroup: this.sliderPerView }
        }
      } else {
        return {
          300: { slidesPerView: 1 },
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: this.sliderPerView }
        }
      }
    },
    showingWrapperClasses () {
      let className = ''

      if (this.$register) {
        className = 'items-start'
        if (this.isCompactLayout) {
          className += ' no-wrap q-mt-sm'
        } else {
          className += ' q-mt-md q-mb-xl q-pa-md justify-evenly'
        }
      } else {
        // consumer app
        if (this.isMoviePage) {
          if (this.isMobileView) {
            className = 'q-mb-sm q-gutter-sm justify-between'
          } else if (this.$q.screen.lt.md) {
            className = 'q-mb-md q-gutter-md'
          } else {
            className = 'q-mb-md q-gutter-lg'
          }
        } else if (this.showtimesListButtonType === SHOWTIMES_BUTTON_TYPES.BASIC && (this.$q.screen.lt.md || this.isPhonePreview)) {
          className = 'justify-between'
        }
      }

      return className
    },
    filledButton () {
      return this.buttonType === BUTTON_TYPES.STANDARD || this.buttonType === BUTTON_TYPES.UNELEVATED
    },
    buttonTextColor () {
      return this.$isColorDark(this.currentSite.primaryColor) ? 'white' : 'black'
    },
    marginTop () {
      if (this.$register) {
        if (this.$q.screen.lt.sm) return '200px'
        return this.allMovies ? '65px' : undefined
      }
      return this.$q.screen.lt.md || this.isPhonePreview ? undefined : '15px'
    },
    siteLocations () {
      return _.filter(this.sites.data, site => !site.isLibrary && !site.consumerConfig.hideOnLocationSelectPage)
    },
    sortedMovieAndShowingsByDate () {
      if (this.closestLocations.length === 0) return this.moviesAndShowingsByDate
      const siteIds = _.map(this.closestLocations, location => _.pick(location, ['id', 'currentDistanceText']))
      const siteIdToMovieMap = new Map()
      _.each(this.moviesAndShowingsByDate, movieAndShowing => {
        siteIdToMovieMap.set(movieAndShowing.movie.site.id, movieAndShowing)
      })
      const sortedMoviesAndShowingsByDate = _.map(siteIds, site => {
        const movie = siteIdToMovieMap.get(site.id)
        if (movie) { movie.currentDistanceText = site.currentDistanceText }
        return movie
      })
      return _.compact(sortedMoviesAndShowingsByDate)
    },
    showCurrentLocationButton () {
      return this.showMultipleSites && this.isMoviePage && !this.currentSite.consumerConfig.showSiteSelectorOnMoviePage && this.geoapifyEnabled
    },
    widgetIncludeBannerBackground () {
      return !this.isMoviePage && this.bannerBackground
    },
    autoResizeMaxClampCount () {
      return this.showMovieSynopsis && this.movieSynopsisWrapped && this.showMovieImage && !this.useBanner && this.showtimesDisplayType === SHOWTIMES_DISPLAY_TYPES.LIST
    }
  },
  watch: {
    moviesAndShowingsByDate: {
      handler: function () {
        if (this.moviesAndShowingsByDate.length === 0) {
          this.$emit('common-showing-badges', [])
        }

        if (this.$consumer && !this.isMobileView) {
          // clear previous maxBannerHeight
          this.maxBannerHeight = null
          this.$nextTick(this.matchHeight)
        }
      },
      immediate: true
    },
    shown () {
      if (this.shown && this.$register && !this.didAutoScrollShowings) {
        this.$nextTick(this.scrollShowingsRowsToClosestShowing)
      }
    },
    showingsByDateAndMovie () {
      if (this.selectedMovieId !== null) {
        this.selectedMovieId = null
      }
    },
    sliderPaginateGroupedSlides () {
      this.changeCount++
    },
    sliderAutoplay () {
      this.changeCount++
    }
  },
  created () {
    _.extend(this, { isNARegion, geoapifyEnabled, formatDate, SHOWTIMES_DISPLAY_TYPES, SHOWTIMES_BUTTON_TYPES, SHOWTIMES_VIEW_TYPES, BUTTON_TYPES })
  },
  mounted () {
    if (this.$register && this.shown) {
      this.$nextTick(this.scrollShowingsRowsToClosestShowing)
    }
    if (this.$consumer && !this.isMobileView) {
      this.$nextTick(this.matchHeight)
    }
    if (this.showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER && this.sliderControlsVisible) {
      this.$nextTick(this.updateControlsButtonStyles)
    }
  },
  methods: {
    getAllShowingBadges (showings) {
      return _(showings).map(showing => showing.showingBadges.data).flatten().compact().uniqBy('id').value()
    },
    getShowingsForDate (showingsByDate, showing) {
      const showingDate = formatDate(showing.siteTime, 'YYYY-MM-DD')
      return showingsByDate[showingDate]
    },
    getShowingBadgesForDate (showingsByDate, showing) {
      const showingDate = formatDate(showing.siteTime, 'YYYY-MM-DD')
      return this.getAllShowingBadges(showingsByDate[showingDate])
    },
    getCommonShowingBadges (showingBadges, showings) {
      return _.filter(showingBadges, showingBadge => !showingBadge.isButtonOnly && _.every(showings, showing => showing.showingBadges.data.includes(showingBadge)))
    },
    getCommonShowingBadgesForDate (showingsByDate, showing) {
      const showingBadgesForDate = this.getShowingBadgesForDate(showingsByDate, showing)
      const showingsForDate = this.getShowingsForDate(showingsByDate, showing)
      return this.getCommonShowingBadges(showingBadgesForDate, showingsForDate)
    },
    getDistinctShowingBadgesForDate (showingsByDate, showing) {
      const showingBadgesForDate = this.getShowingBadgesForDate(showingsByDate, showing)
      const showingsForDate = this.getShowingsForDate(showingsByDate, showing)
      const commonShowingBadgesForDate = this.getCommonShowingBadges(showingBadgesForDate, showingsForDate)
      return _.filter(showing.showingBadges.data, showingBadge => !commonShowingBadgesForDate.includes(showingBadge))
    },
    scrollShowingsRowsToClosestShowing () {
      if (!this.isCompactLayout) return

      const showingsRows = document.querySelectorAll('.main-display .showings')
      let scrolled = false

      _.forEach(showingsRows, (rowEl) => {
        const showingEl = rowEl.querySelector('[data-showing-upcoming]') || rowEl.querySelector('[data-showing-started]')
        if (showingEl) {
          const scrollableContainer = scroll.getScrollTarget(showingEl)
          const offsetLeft = showingEl.offsetLeft

          // This component may be rendered but not visibly shown because it's not
          // the current POS tab. On most browsers, un-displayed elements have zero-values
          // for dimensions and offsets, so scrolling does nothing and we shouldn't count it.
          if (offsetLeft > 0) {
            const scrollAnimationMs = 1000
            scroll.setHorizontalScrollPosition(scrollableContainer, offsetLeft, scrollAnimationMs)
            scrolled = true
          }
        }
      })

      if (scrolled) {
        this.didAutoScrollShowings = true
      }
    },
    showHeldSeatDialog (showing) {
      if (this.$register) this.$emit('edit-held-seats', showing)
    },
    disabled (showing) {
      if (showing.seatsRemaining <= 0) return true
      if (showing.hasPurchaseEmbargo) return true

      if (this.$register && this.allowPastShows) return false

      if (this.$consumer) return !showing.validOnlinePurchaseTime

      return false
    },
    availableColor (showing) {
      const ratio = showing.seatsRemaining / (showing.screen.seatCount - showing.heldSeatCount)

      if (ratio < 0.25) {
        return 'negative'
      } else if (ratio < 0.5) {
        return 'warning'
      } else {
        return 'positive'
      }
    },
    multipleScreens (showing, showings) {
      return _.filter(showings, other => other.siteTime.getTime() === showing.siteTime.getTime()).length > 1
    },
    getRelativeDateHeading (date) {
      const today = this.$d(this.currentSite.siteTime, 'mediumLongDate')
      const tomorrow = this.$d(addToDate(this.currentSite.siteTime, { days: 1 }), 'mediumLongDate')
      const formattedDate = this.$d(new Date(date + 'T00:00'), 'mediumLongDate')
      const day = formattedDate === today ? this.$i18n.t('time.today') : formattedDate === tomorrow ? this.$i18n.t('time.tomorrow') : ''
      return [day, formattedDate]
    },
    attendanceBadge (showing) {
      if (!this.shouldShowAttendanceIcons) return null

      const attendance = this.usePredictedAttendance ? showing.predictedAttendance : showing.ticketsSold

      if (attendance === 0) return null

      const heldSeats = showing.overrideHeldSeatCount ? showing.customHeldSeatCount : showing.screen.heldSeatCount
      const capacity = showing.screen.seatCount - heldSeats
      const percentageSold = Math.floor((attendance / capacity) * 100)

      if (percentageSold < 50) return null

      const busyMessage = this.usePredictedAttendance ? 'Expected to be busy' : 'Selling fast!'
      const almostSoldOutMessage = this.usePredictedAttendance ? 'Expected to be VERY busy' : 'Almost gone!'
      const soldOutMessage = this.usePredictedAttendance ? 'Expected to sell out' : 'Sold out!'
      const title = percentageSold >= 100 ? soldOutMessage : percentageSold >= 90 ? almostSoldOutMessage : busyMessage

      return {
        type: 'icon',
        iconName: 'whatshot',
        title
      }
    },
    showTimeslots (movieId) {
      this.selectedMovieId = this.selectedMovieId === movieId ? null : movieId
    },
    ticketLimitMessage (showing) {
      const ticketLimit = showing.ticketLimit
      const seatsRemaining = showing.seatsRemaining
      return ticketLimit && (ticketLimit < seatsRemaining) ? `Limit ${ticketLimit} tickets per order` : this.$i18n.tc('ticket.ticketsRemainingCount', seatsRemaining || 0)
    },
    matchHeight () {
      // fix button alignment issue
      const bannerInfoBlocks = document.querySelectorAll('.banner-info')
      const heightDataSet = []
      _.forEach(bannerInfoBlocks, (bannerInfoBlock) => {
        const height = bannerInfoBlock.getBoundingClientRect().height
        heightDataSet.push(height)
      })
      const highest = Math.max(...heightDataSet)
      this.maxBannerHeight = highest
    },
    handleCurrentLocationRequest () {
      this.loading = true
    },
    async handleCurrentLocationResult (origin) {
      if (origin) {
        this.closestLocations = await this.$geoapify.getClosestLocations(origin, this.siteLocations)
      }
      this.loading = false
    },
    updateControlsButtonStyles () {
      const nextButton = document.querySelector('.swiper-button-next')
      const prevButton = document.querySelector('.swiper-button-prev')

      if (nextButton && prevButton) {
        prevButton.style.left = '0'
        prevButton.style.color = 'white'
        prevButton.style.textShadow = '0 0 3px rgba(0, 0, 0, 0.5)'

        nextButton.style.right = '0'
        nextButton.style.color = 'white'
        prevButton.style.textShadow = '0 0 3px rgba(0, 0, 0, 0.5)'
      }
    },
    onResize (movieID, size) {
      this.maxSynopsisLineClampCounts[movieID] = Math.floor(size.height / 24)
    },
    getWebkitLineClampCounts (movieID) {
      if (!this.movieSynopsisWrapped) {
        return undefined // If synopsis isn't wrapped, return undefined early.
      }

      // Check for auto-resize max clamp count and mobile view
      if (this.autoResizeMaxClampCount) {
        const maxClampCount = this.maxSynopsisLineClampCounts[movieID] || 0
        const customLineCount = this.isMobileView ? this.mobileTruncatedLineCount : this.truncatedLineCount
        return customLineCount > maxClampCount && maxClampCount > 0
          ? maxClampCount
          : customLineCount
      }

      // Default behavior if no auto-resize
      return this.isMobileView ? this.mobileTruncatedLineCount : this.truncatedLineCount
    }
  }
}
</script>

<style lang="scss" scoped>
.main-display {
  flex-direction: row;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.movie-container.no-background {
  background-color:rgba(150, 150, 150, 0.2);
}
.movie-container.no-background:nth-child(odd) {
  background-color:rgba(150, 150, 150, 0.3);
}

.poster {
  width: 200px;
  max-width: 200px;
  border-radius: 7px;
  margin: 5px;

  &.compact {
    margin: 0;
  }
}
.movie-name {
  max-width: 200px;
  font-size: 18px;
  padding: 7px;
}

.poster.register {
  width: 120px;
  border-radius: 0px;
}

.message {
  text-align: center;
}
.attendance-bar{
  height: 6px;
  transition: all 0.3s ease-in-out;
  margin: -7px 1px 0;
  border-radius: 0 0 3px 3px;
  &:hover{
    height: 10px;
    margin: -11px 1px 0;
  }

  &.compact-button{
    border-radius: 0 0 5px 5px;
    margin: -6px 0px 0;
    &:hover{
      height: 10px;
      margin: -10px 0px 0;
    }
  }
  &.slider-button{
    margin: -9px 1px 0;
    &:hover{
      height: 9px;
      margin: -12px 0px 0;
    }
  }
}

.poster-image-container {
  background-image: initial;
  background-position-x: initial;
  background-position-y: initial;
  background-size: initial;
  background-attachment: initial;
  background-origin: initial;
  background-clip: initial;
  overflow-x: hidden;
  overflow-y: hidden;
  min-height: 165px;
  transition: height 0.1s ease-in-out;
  cursor: pointer;
}

.poster-image {
  width: 100%;
}

.poster-info {
  z-index: 1;
  height: 165px;
  margin-top: -165px;
  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));
  cursor: pointer;

  &.leaves-soon{
    height: 180px;
    margin-top: -180px;
  }
}
.banner-info {
  cursor: pointer;
}
.poster-title {
  font-size: 1.2rem;
  line-height: 1.3rem;
}

.poster-subtitle {
  font-size: 1.2rem;
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: hidden;
}

.poster-slot {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.poster-slot_time {
  padding-top: 10px;
  padding-right: 0px;
  padding-bottom: 12px;
  padding-left: 0px;
  transition-duration: 0.1s;
  transition-timing-function: ease-in-out;
  transition-delay: 0s;
  transition-property: all;
  box-shadow: rgba(0, 0, 0, 0.1) 0px -3px 2px inset;
  cursor: pointer;

  .q-chip--dense{
    height: 0;
  }
}

.poster-slot_time:hover {
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px inset;
  padding-bottom: 10px;
  margin-top: 6px;
}

.toggle-btn.active{
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.message {
  font-size: 32px;
  text-align: center;
}

:deep(.q-scrollarea.bg-responsive .q-scrollarea__content){
   max-width: 100%;
}

@media (min-width: $breakpoint-md-min) {
  .row > .width-lg-20percent {
      height: auto;
      width: 20%;
  }
}
</style>
